import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { parseISO } from "date-fns";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a date-only string (YYYY-MM-DD) without timezone issues.
 * Using new Date('2026-06-16') interprets it as UTC midnight, which becomes
 * the previous day in US timezones. This function adds noon time to ensure
 * correct local date interpretation.
 *
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {Date} - Date object with correct local date
 */
export function parseDateOnly(dateStr) {
  if (!dateStr) return new Date();
  // If it's just a date (YYYY-MM-DD), add noon time to avoid timezone edge cases
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return parseISO(`${dateStr}T12:00:00`);
  }
  // If it already has time info, parse as-is
  return parseISO(dateStr);
}